import React from 'react'
import classes from './Modal.module.scss'
import { ItineraryTrain } from '../../../atom/Types'
import Close from '@mui/icons-material/Close'
import { CloseButtonSvg, DateSvg, LocationSvg, TrainSvg } from '../../../constants/resources'
import moment from 'moment'
import { Time, checkSpacing } from '../../../atom/utilities/function'


interface props {
    TrainDetails: ItineraryTrain[]
    handleTrain: (node: ItineraryTrain[], m: string,) => void
    activeTrain: ItineraryTrain | {}
    setActiveTrain: React.Dispatch<React.SetStateAction<{} | ItineraryTrain>>
    buliddata: any
}

const TrainModal: React.FC<props> = ({ TrainDetails, handleTrain, activeTrain, setActiveTrain, buliddata }) => {
    const handleSelection = (train: ItineraryTrain) => {
        if ('id' in activeTrain && train.id === activeTrain.id)
            setActiveTrain({})
        else
            setActiveTrain(train)
    }
    return (
        <div className={classes.ModalBackground}>
            <div className={classes.scrollModalContent}>
                <div className={classes.Flex}>
                    <div className={classes.modalTop}>
                        <div className={classes.header}>Select a Train</div>
                        <div className={classes.flightTop}>
                            <button className={classes.CloseButton} onClick={() => handleTrain(TrainDetails, 'close')}>
                                <Close className={classes.closesvg} />
                            </button>
                        </div>
                    </div>
                    <hr />
                </div>
                <div style={{ display: 'flex', flexDirection: 'column' }}>
                    <div className={classes.carScrollContainer}>

                        {TrainDetails?.map((train, index) => {
                            return <div key={index} className={'id' in activeTrain && train.id === activeTrain?.id ? classes.mainViewSelected : classes.mainView}>
                                <div className={classes.displayView}>
                                    <div className={classes.carContainer}>
                                        <div className={classes.carHead}>
                                            <div>{train?.train?.trainCompany}</div>
                                        </div>
                                        {train?.class !== "" || train?.trainType !== "" ? <div style={{ display: "flex", gap: '4px', flexDirection: 'row', }}>
                                            {train?.trainType !== "" ? <div className={classes.carProperties}>{train?.trainType}</div> : null}
                                            {train?.class !== " " ? <div className={classes.carProperties}>{train?.class}</div> : null}
                                        </div> : null}
                                        {train?.trainNumber !== '' ? <div style={{ display: "flex", flexDirection: 'row', gap: '6px' }}>
                                            <div>
                                                <TrainSvg />
                                            </div>
                                            <div style={{ display: "flex", flexDirection: "column" }}>
                                                <div className={classes.carDetails}>Train number</div>
                                                <div>{train?.trainNumber}</div>
                                            </div>
                                        </div> : null}
                                        <div style={{ display: "flex", flexDirection: 'row', gap: '6px' }}>
                                            <div>
                                                <DateSvg />
                                            </div>
                                            <div style={{ display: "flex", flexDirection: "column" }}>
                                                <div className={classes.carDetails}>Departure date</div>
                                                <div style={{ width: "272px", fontSize: '16px' }}>{moment.utc(train?.departDate).format('MMM DD')} at {Time(train?.departTime)}</div>
                                            </div>
                                        </div>
                                        <div style={{ display: "flex", flexDirection: 'row', gap: '6px' }}>
                                            <div>
                                                <DateSvg />
                                            </div>
                                            <div style={{ display: "flex", flexDirection: "column" }}>
                                                <div className={classes.carDetails}>Arrival date</div>
                                                <div style={{ width: "272px", fontSize: '16px' }}>{moment.utc(train?.arrivalDate).format('MMM DD')} at {Time(train?.arrivalTime)}</div>
                                            </div>
                                        </div>
                                        <div style={{ display: "flex", flexDirection: 'row', gap: '6px' }}>
                                            <div>
                                                <LocationSvg width={"13px"} height={"12px"} />
                                            </div>
                                            <div style={{ display: "flex", flexDirection: "column" }}>
                                                <div className={classes.carDetails}>Departure Station</div>
                                                <div style={{ width: "272px", fontSize: '16px' }}>{train?.train?.departureCity}</div>
                                            </div>
                                        </div>

                                        <div style={{ display: "flex", flexDirection: 'row', gap: '6px' }}>
                                            <div>
                                                <LocationSvg width={"13px"} height={"12px"} />
                                            </div>
                                            <div style={{ display: "flex", flexDirection: "column" }}>
                                                <div className={classes.carDetails}>Arrival Station</div>
                                                <div style={{ width: "272px", fontSize: '16px' }}>{train?.train?.arrivalTrainStation}</div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className={classes.carPrice}>
                                        <p className={classes.price}>{train?.price !== null && train?.price !== 0 ? `$ ${train?.price}` : null}</p>
                                        <p style={{ textAlign: "left" }} dangerouslySetInnerHTML={{ __html: checkSpacing(train?.comment) ? train?.comment : '' }}></p>
                                        <p style={{ fontSize: '14px', color: '#FF3566' }}>{train?.cancellationPolicy}</p>
                                    </div>
                                </div>
                                {buliddata.type === 'Proposal' && <div style={{ display: 'flex', justifyContent: 'center' }}><button className={'id' in activeTrain && train?.id === activeTrain?.id ? classes.subButtonSelected : classes.subButton} onClick={() => handleSelection(train)}>{'id' in activeTrain && train?.id === activeTrain?.id ? <span>
                                    <CloseButtonSvg />
                                    Clear Choice</span> : "Choose"}</button></div>}
                            </div>
                        })}
                    </div>
                </div>
                {buliddata.type === 'Proposal' ? <div className={classes.carButton}><button disabled={Object.keys(activeTrain).length > 0 ? false : true} onClick={() => handleTrain(TrainDetails, 'choose')}>Confirm</button></div>
                    :
                    TrainDetails[0]?.selected ?
                        <div className={classes.ClearChoice}>
                            <button onClick={() => { handleTrain(TrainDetails, 'choose') }}>
                                <Close style={{ marginRight: "8px", color: "#FF3566", transform: "scale(0.8)" }} />
                                Clear choice
                            </button>
                        </div> :
                        <div className={classes.Choose}>
                            <button onClick={() => handleTrain(TrainDetails, 'choose')}>
                                Choose
                            </button>
                        </div>
                }

            </div>
        </div>
    )
}

export default TrainModal